/**
 * Host entitlement resolver (Sprint 6B).
 * Maps existing Helper.redirectStatus outcomes + video flags → EntitlementSnapshot.
 * Does not implement billing — consumes backend decisions.
 */
import {
  EntitlementAction,
  EntitlementRedirectKind,
  createEntitlementSnapshot,
  inferMonetizationFromDetails,
} from "../Core/EntitlementModel";

/**
 * @param {object} details video DTO
 * @param {object} [opts]
 * @param {string|null} [opts.redirectStatus] result of Helper.redirectStatus
 * @param {boolean} [opts.isTrailer]
 * @returns {object} entitlement snapshot
 */
export function resolveHostEntitlements(details, opts) {
  opts = opts || {};
  var base = inferMonetizationFromDetails(details, {
    isTrailer: !!opts.isTrailer,
  });

  var gate = opts.redirectStatus;
  if (!gate || gate === "ok" || gate === true) {
    return createEntitlementSnapshot(
      Object.assign({}, base, {
        action: EntitlementAction.ALLOW,
        redirectKind: EntitlementRedirectKind.NONE,
      })
    );
  }

  if (gate === "ppv") {
    return createEntitlementSnapshot(
      Object.assign({}, base, {
        action: EntitlementAction.REDIRECT,
        redirectKind: EntitlementRedirectKind.PPV,
        redirectPath: "/pay-per-view",
      })
    );
  }
  if (gate === "payment") {
    return createEntitlementSnapshot(
      Object.assign({}, base, {
        action: EntitlementAction.REDIRECT,
        redirectKind: EntitlementRedirectKind.PAYMENT,
        redirectPath: "/payment-options",
      })
    );
  }
  if (gate === "subscription") {
    return createEntitlementSnapshot(
      Object.assign({}, base, {
        action: EntitlementAction.REDIRECT,
        redirectKind: EntitlementRedirectKind.SUBSCRIPTION,
        redirectPath: "/subscription",
      })
    );
  }

  return createEntitlementSnapshot(
    Object.assign({}, base, {
      action: EntitlementAction.DENY,
      redirectKind: EntitlementRedirectKind.NONE,
    })
  );
}

export default resolveHostEntitlements;
